// extracted by mini-css-extract-plugin
export default {"root":"MultiSessionFeaturesList__root--_DBCO","item":"MultiSessionFeaturesList__item--1m117"};